<template>
  <div class="usernamesearch" id="searchforlist">
    <div class="row flex-1" @click.stop>
      <div class="fw100" ref="outinput">
        <el-input
          ref="patientInputBox"
          style="border-radiour"
          class="flex-1"
          clearable
          :placeholder="placeholder"
          v-model="userName"
          @focus.stop="showsearch"
          @input="changeSearch"
          @clear="clearinput"
          maxlength="32"
          show-word-limit
          :disabled="disabled"
        ></el-input>
      </div>
    </div>
    <div
      class="usernamesearchlist"
      v-if="searchList.isShow"
      :style="{
        width: '360px',
        left: fixdleft,
        top: fixdTop,
        maxHeight: maxheight + 'px',
      }"
      ref="searchlist"
    >
      <div class="total row space-around fixedtop">
        <div class="flex-1">
          <span v-show="findPatientTextshow">共找到{{ total }}个患者</span>
          <span v-show="!findPatientTextshow">正在加载...</span>
        </div>
        <div>
          <el-checkbox
            v-model="orderType"
            :true-label="1"
            :false-label="0"
            @change="orderTypechange"
            >按就诊时间排序</el-checkbox
          >
        </div>
        <!--
          isShareData:诊所设置是否共享数据
          isArchiveD：归档D
        -->
        <!-- <div -->
        <!-- class="ml10 mr10" -->
        <!-- v-if="isShareData == 1 && !isArchiveD && !checkOnlyThisShop" -->
        <!-- > -->
        <!-- <el-checkbox -->
        <!-- v-model="queryRange" -->
        <!-- :true-label="1" -->
        <!-- :false-label="0" -->
        <!-- @change="queryRangeChange" -->
        <!-- >连锁</el-checkbox -->
        <!-- > -->
        <!-- </div> -->
      </div>
      <ol class="userlist">
        <li
          @click.stop="hideSearch(item)"
          v-for="(item, index) in searchList.list"
          :key="index"
          class="li"
        >
          <div class="line name">
            <div class="nameleft">
              <!-- <Userheader
                class="mr10"
                :headboxwidth="'26px'"
                :sex="item.sexLabel"
                :age="item.age"
              >
              </Userheader> -->
              {{ item.patientName }}
              <span
                :style="{
                  marginLeft: '4px',
                  width: '18px',
                  height: '18px',
                  backgroundColor: 'rgba(38, 179, 189, 1)',
                  borderRadius: '50%',
                  fontSize: '10px',
                  color: '#fff',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }"
                v-if="item.sexLabel === '男'"
                >男</span
              >
              <span
                :style="{
                  marginLeft: '4px',
                  width: '18px',
                  height: '18px',
                  backgroundColor: 'rgba(230, 162, 60, 1)',
                  borderRadius: '50%',
                  fontSize: '10px',
                  color: '#fff',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }"
                v-if="item.sexLabel === '女'"
                >女</span
              >
            </div>
          </div>
          <div class="line">
            <div class="nameright">
              <span
                :style="{
                  fontSize: '12px',
                  marginLeft: '2px',
                  textOverflow: 'ellipsis',
                  width: '84px',
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  lineHeight: '1',
                }"
                >{{ item.clinicName }}</span
              >
            </div>
          </div>
          <div class="line row flex-center flex-wrap">
            <i
              class="iconfont icon-Drup mr4"
              :style="{ fontSize: '17px !important' }"
            ></i>
            {{ item.medicalNo }}
            <div
              :style="{ display: 'inline-block' }"
              class="ml10"
              v-if="item.age !== null"
            >
              {{ item.age }} 岁<span v-if="item.birthday"
                >({{ item.birthday }})</span
              >
            </div>
          </div>
          <div
            class="line row flex-center flex-wrap"
            v-if="item.phone && item.phone != ''"
          >
            <i class="iconfont icon-iphone mr4"></i>{{ item.phone }}
          </div>
          <div class="line" v-if="item.consultantName">
            <span>咨询师：{{ item.consultantName || "暂无" }} </span>
          </div>
          <div class="line" v-if="item.firstVisitTime">
            <span
              >初次就诊：{{ item.firstVisitTime }}
              {{ getWeekdayfont(item.firstVisitTime) }}
              {{ item.firstVisitDoctorName }}</span
            >
          </div>
          <div class="line" v-if="item.lastVisitTime">
            <span
              >最近就诊：{{ item.lastVisitTime }}
              {{ getWeekdayfont(item.lastVisitTime) }}
              {{ item.lastVisitDoctorName }}
            </span>
          </div>
          <div class="line" v-if="item.patientRemark">
            <span
              >备注：<PcTextmore
                :value="item.patientRemark || '暂无'"
                :max="18"
              ></PcTextmore>
            </span>
          </div>
        </li>
      </ol>

      <div :style="{ fontSize: '10px', width: '100%', textAlign: 'center' }">
        <el-button v-if="nomore" type="text">没有更多了</el-button>
        <el-button v-else type="text" @click.stop="more"
          >点击加载更多</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMiniDetail,
  hightSelectPatient,
} from "@/api/pc/patientinformation.js";
//util
import tool from "@/util/debounce.js";
import func from "@/util/func";
//assets
import sexman from "@/assets/img/avatar/man.png";
import sexwoman from "@/assets/img/avatar/woman.png";
// import { getStoreinfo } from "@/api/chain/group/shopmanage.js";

export default {
  name: "searchfor",
  props: {
    // userName: {
    //   type: String,
    //   required: false,
    //   default: "",
    // },
    oninputClear: {
      //是否在输入时判断清空
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "姓名/手机号/病历号",
    },
    needotherParameters: {
      //是否有其他参数参与搜索
      type: Boolean,
      required: false,
      default: false,
    },
    otherParameters: {
      //参与搜索的对象
      type: Object,
      required: false,
      default: {},
    },
    checkOnlyThisShop: {
      //仅查看本店
      type: Boolean,
      default: false,
    },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.timer = null;
  },
  data: function () {
    return {
      userName: "",
      searchList: {
        isShow: false,
        list: [],
      },
      queryRange: 0, //默认是本店
      orderType: 0, //0 不排序 1排序 根据就诊时间排序
      sexman: sexman,
      sexwoman: sexwoman,
      current: 1,
      total: 0,
      nomore: false,
      lefttype: "0",
      sortValues: "", //高级搜索传回来的字段
      findPatientTextshow: false, //搜索框是否显示
      isShareData: 0,
      fixdleft: 0,
      fixdtop: 0,
      maxheight: 580,
    };
  },
  mounted: function () {
    let that = this;
    // add event listeners with the same options so they can be removed later
    document.addEventListener("click", this.windowclickhide, false);
    window.addEventListener("scroll", this.scrollUpdatePosition, true);

    // getStoreinfo(this.curentclinic.id).then((res) => {
    //   let data = res.data.data;
    //   let { isShareData } = data;
    //   this.isShareData = isShareData;
    // });
  },
  methods: {
    windowclickhide(event) {
      let that = this;
      try {
        let isSelf =
          this.$refs.searchlist.contains(event.target) ||
          this.$refs.outinput.contains(event.target); // 这个是自己的区域

        if (!isSelf) {
          that.searchList.isShow = false;
        } else {
        }
      } catch (error) {
        // console.log(error);
      }
    },
    getWeekdayfont(dateStr) {
      if (!dateStr) return "";
      try {
        const d = new Date(dateStr);
        const weekdays = [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六",
        ];
        return weekdays[d.getDay()];
      } catch (e) {
        return "";
      }
    },
    changeLefttype(e) {
      const that = this,
        { timer } = this;
      if (timer) {
        clearTimeout(timer);
      }
      if (!that.userName || that.userName == "") {
        that.searchList.isShow = false;
      } else {
        that.searchList.isShow = true;
      }
      this.lefttype = e;
      that.current = 1;
      this.lefttype = e;
      this.getListPage();
    },
    blur() {},
    more() {
      this.current += 1;
      this.getListPage();
    },

    changeSearch: tool._debounce(function (e) {
      const that = this;
      if (this.oninputClear) {
        this.clearinput();
      }

      if (e == "") {
        that.searchList.isShow = false;
        this.clearinput();
        return;
      }

      that.initializationPosition();
      that.searchList.isShow = true;
      that.current = 1;
      that.findPatientTextshow = false;
      that.getListPage();
    }, 800),
    initializationPosition() {
      //获取患者搜索的定位位置
      let that = this;

      if (!this.$refs.patientInputBox) {
        return;
      }

      const outboxel = this.$refs.patientInputBox.$el;
      if (func.isEmpty(outboxel)) {
        return;
      }
      const inputRect = outboxel.getBoundingClientRect();
      const searchListEl = this.$refs.searchlist;
      //距离到底部的位置算出

      const windowHeight = window.innerHeight;
      let distanceToBottom = windowHeight - inputRect.bottom - 20;

      if (distanceToBottom > 580) {
        distanceToBottom = 580;
      } else if (distanceToBottom < 180) {
        distanceToBottom = 180;
      }

      that.fixdleft = inputRect.left + "px";
      that.fixdTop = inputRect.bottom + 2 + "px";
      that.maxheight = distanceToBottom;

      if (!func.isEmpty(searchListEl)) {
        searchListEl.style.top = inputRect.bottom + 2 + "px";
        searchListEl.style.left = inputRect.left + "px";
        searchListEl.style.maxHeight = distanceToBottom + "px";
      }
    },
    scrollUpdatePosition() {
      //监听全局滚动
      // let that=this;
      this.initializationPosition();
    },
    hideSearch(record, handleEmit = true) {
      const that = this;
      that.searchList.isShow = false;
      if (handleEmit) {
        that.$emit("func", {
          ...record,
        });
      }
      that.userName = record.patientName;
    },
    clearinfo() {
      //清空用户名
      this.userName = "";
    },
    clearinput() {
      this.$emit("func", { id: "", lefttype: this.lefttype, medicalNo: "" });
    },
    queryRangeChange() {
      let that = this;
      that.findPatientTextshow = false;
      that.current = 1;
      that.searchList.list = [];
      this.getListPage();
    },
    getListPage() {
      const that = this;
      const { current, userName, searchList, orderType, lefttype, queryRange } =
        that;
      //新版本搜索
      let subdata = {
        current,
        search: userName,
        orderType,
        sortValues: that.sortValues,
        queryRange,
      };

      //如果需要从外部传参拼接外部传参
      if (that.needotherParameters) {
        subdata = {
          ...subdata,
          ...that.otherParameters,
        };
      }

      hightSelectPatient(subdata)
        .then((res) => {
          const { total, records } = res.data.data;
          records.forEach((item) => {
            const phones = [];
            if (item.contactNo1) {
              phones.push(item.contactNo1 + "(" + item.contactType1 + ")");
            }
            if (item.contactNo2) {
              phones.push(item.contactNo2 + "(" + item.contactType2 + ")");
            }
            if (item.contactNo3) {
              phones.push(item.contactNo3 + "(" + item.contactType3 + ")");
            }
            item.phones = phones.join(",");
          });

          that.nomore = total <= 50 || records.length == 0;
          that.total = total;
          that.findPatientTextshow = true;
          records.length == 0
            ? (that.sortValues = "")
            : (that.sortValues = records[records.length - 1].sortValues);
          if (current === 1) {
            if (!records || records.length <= 0) {
              searchList.list = [];
            } else {
              searchList.list = records;
            }
          } else {
            records.forEach((item) => {
              searchList.list.push(item);
            });
          }
        })
        .catch((res) => {});
    },
    loaerinfo(id, handleEmit = true) {
      let that = this;
      if (func.isEmpty(id)) {
        return;
      } else {
      }
      let params = {
        ids: id,
      };
      hightSelectPatient(params).then((res) => {
        let { records } = res.data.data;
        records.forEach((item) => {
          const phones = [];
          if (item.contactNo1) {
            phones.push(item.contactNo1 + "(" + item.contactType1 + ")");
          }
          if (item.contactNo2) {
            phones.push(item.contactNo2 + "(" + item.contactType2 + ")");
          }
          if (item.contactNo3) {
            phones.push(item.contactNo3 + "(" + item.contactType3 + ")");
          }
          item.phones = phones.join(",");
        });

        let item = records[0];
        if (!func.isEmpty(item)) {
          that.hideSearch(item, handleEmit);
        }
      });
    },
    orderTypechange() {
      let that = this;
      that.current = 1;
      that.findPatientTextshow = false;
      that.searchList.list = [];
      this.getListPage();
    },
    showsearch() {
      let that = this;

      if (that.userName.length > 1) {
        that.initializationPosition();
        that.searchList.isShow = true;
      } else {
      }
    },
    getUserNameById(id) {
      if (id) {
        getMiniDetail(id).then((res) => {
          const { data } = res.data;
          this.userName = data.patientName;
        });
      }
    },
  },
  beforeUnmount() {
    // remove the exact listeners added in mounted
    try {
      window.removeEventListener("scroll", this.scrollUpdatePosition, true);
      document.removeEventListener("click", this.windowclickhide, false);
    } catch (e) {
      // ignore
    }
  },
};
</script>
<style lang="scss" scoped>
.fw100 {
  width: 100%;
}
:deep(.clearPadding .vxe-cell) {
  padding: 0;
}
:deep(.clearPaddingLeft .vxe-cell) {
  padding-left: 0px;
}
.el-switch__label * {
  font-size: 12px;
}
:deep(.main-el-switch) {
    position: relative;
    .el-switch__label * {
      font-size: 12px !important;
    }
    .el-switch__core {
      height: 22px;
      border-radius: 12px;
      &:after {
        left: 4px;
        top: 3px;
      }
    }
    &.el-switch {
      &.is-checked {
        .el-switch__core {
          &:after {
            margin-left: -20px;
            left: 100%;
          }
        }
      }
    }
    &.is-checked {
      .el-switch__label--left {
        opacity: 0;
      }
      .el-switch__label--right {
        opacity: 1;
      }
    }
    .el-switch__label {
      position: absolute;
      top: 0;
    }
    .el-switch__label--left {
      right: 0;
      color: #999;
      z-index: 1;
      margin-right: 8px;
    }
    .el-switch__label--right {
      left: 0;
      color: #fff;
      opacity: 0;
      margin-left: 8px;
    }
}
.top-bar__left i,
.top-bar__right i {
  line-height: 25px;
}
.usernamesearchlist {
  text-align: left;
  position: fixed;
  max-height: 580px;
  overflow-y: scroll;
  overflow-x: hidden;
  box-shadow: 0px 4px 8px -2px rgba(0, 0, 0, 0.06),
    0px 8px 16px rgba(0, 0, 0, 0.04), 0px 8px 32px 8px rgba(0, 0, 0, 0.02);
  // width: 410px;
  width: 370px;
  background-color: #fff;
  border: 1px solid #ededed;
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-sizing: border-box;
  padding: 0 6px;
  z-index: 999 !important;
  .fixedbottom {
    position: sticky;
    bottom: 0;
    width: 100%;
    height: 40px;
    background: #ffffff;
    z-index: 99;
  }

  .fixedtop {
    position: sticky;
    top: 0;
    width: 100%;
    height: 40px;
    background: #ffffff;
    z-index: 99;
  }

  .el-input__inner {
    border-radius: 1px;
  }

  .total {
    color: rgba(144, 147, 153, 1);
    font-size: 12px;
    padding: 10px;
  }

  .userlist {
    li {
      padding: 0 10px;
      border-top: 1px solid #ededed;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.3s;
      padding-bottom: 6px;

      &:hover {
        background-color: #efefef;
      }

      // .line {
      //   line-height: 20px !important;
      // }

      .name {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        margin-top: 8px !important;
        align-items: center;
        justify-content: space-between;

        .nameleft {
          display: flex;
          align-items: center;
        }

        .avatar {
          margin-right: 4px;
        }
      }
    }
  }
}

.usernamesearch {
  display: inline-block;
  .el-input {
    border-color: #e6e6e6;
    :deep(.el-input__wrapper) {
      padding: 2px 11px 1px;
    }
  }
}

.el-link {
  margin: 0 auto;
  width: 100%;
  text-align: center;
}

.usernamesearch {
  width: 100%;
  max-width: 280px;
  position: relative;
  z-index: 40;
}
.line {
  line-height: 25px;
}
</style>
